<template>

<div class="modal" id="printEPLModal" tabindex="-1">
  <div class="modal-dialog modal-lg ">
    <div class="modal-content ">
      <div class="modal-header border-primary">
        <h5 style="color:navy" class="modal-title">
           <i  class="fa fa-print mr-2" ></i>
          <strong>STAMPA ETICHETTE</strong>
        </h5>
          <button type="button" @click="$emit('close')" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
      </div>
        <div class="modal-body">
        <div class="content" role="main">
        <div>
          <fieldset>
          <legend></legend>
          <Printers  v-show="showPrinters" :spinner="spinner" :printer_list="printers" :Id="selected_printer" v-on:change="onPrinterChange" />
            
            
            <label class="mt-3" for="labelFormat"><strong>Formato Etichetta</strong>
            </label>

         <select @change="_setLabelId(selected_label)" class="form-control " id="labelFormat" v-model="selected_label">
            <!--<option disabled n-bind:key="undefined">Seleziona formato etichetta</option>-->
            <option  v-for="(label,index) in label_list" :value="label.Id" :key="index">{{ label.name }}</option>
        </select>

         <button  class="btn btn-info mt-1 btn-block"  @click="setDefault()">SALVA IMPOSTAZIONI DI STAMPA
        
        </button> 

          </fieldset>
     
     
        
        <button :disabled="labelCount==0" class="btn btn-primary mt-5 "  v-on:click="doPrintLabels()">STAMPA <span class="badge badge-light ml-2 mr-2">{{labelCount}}</span> ETICHETT{{labelCount ==1 ? 'A':'E' }}   
         <!--<span class="badge badge-light ml-2 mr-2">{{labelCount}}</span>-->
        </button>
      
      
    </div>

  </div>

  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  </div>
    <!--
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" data-dismiss="modal">Chiudi</button>
    </div>
    -->

</div>
</div>
</div>


</template>

<script>

import { mapGetters }   from 'vuex';
import alertBox         from './AlertBox.vue'
import Printers         from "./Printers";
import JSPM             from "jsprintmanager";
import {requestPrint}   from  "@/bixolon"
import bxl              from '@/components/mixins/Bixolon.js'
import fmt              from '@/components/mixins/fmt.js'



export default {
  name: "",
  props: ["data"],
  components: {
    Printers,alertBox
  },
    mixins:[bxl,fmt],
  data: function () {
    return {
      print2default   : false,
      printers        : [],
      showPrinters    : true,
      label_list      : [
        
        {'name':'70 x 30 (EPL)','Id':0,'code':'EPL','showPrinters':true},
        {'name':'50 x 40 (EPL)','Id':1,'code':'EPL','showPrinters':true},
        {'name':'50 x 30 (EPL)','Id':2,'code':'EPL','showPrinters':true},
        {'name':'40 x 30 (DATAMAX)','Id':3,'code':'DATAMAX','showPrinters':true},
        {'name':'40 x 30 (TLP 2844)','Id':4,'code':'EPL','showPrinters':true},

        {'name':'40 x 30 (EPL)','Id':5,'code':'EPL','showPrinters':true},
        {'name':'40 x 30 (TLP 2844/A)','Id':6,'code':'EPL','showPrinters':true},
        {'name':'50 x 40 (GODEX EPL)','Id':7,'code':'GODEX_EPL','showPrinters':true},
        {'name':'50 x 40 (GODEX EZPL)','Id':8,'code':'EZPL','showPrinters':true},
        {'name':'50 x 40 (BIXOLON STANDARD)','Id':9,'code':'ZPL_STANDARD','showPrinters':true},
        {'name':'50 x 40 (BIXOLON DOPPIO PREZZO)','Id':10,'code':'ZPL_DP','showPrinters':true},
        {'name':'68 x 45 BIXOLON ','Id':11,'code':'BIXOLON_68_45','showPrinters':true},
        {'name':'70 x 40 HOLAMOSA ','Id':12,'code':'HOLAMOSA','showPrinters':true},

        {'name':'70 x 30 SDK BIXOLON CLUB','Id':13,'code':'BIXOLON_SDK_CLUB','showPrinters':false},
        {'name':'70 x 30 SDK BIXOLON','Id' : 14,'code':'BIXOLON_SDK_CLUB','showPrinters':false},
        {'name':'50 x 40 SDK BIXOLON','Id' : 15,'code':'BIXOLON_SDK_50x40','showPrinters':false},
        
        {'name':'30 x 40 (TLP-2844-)','Id':16,'code':'EPL','showPrinters':true},
        {'name':'40 x 30 SDK BIXOLON','Id' : 17,'code':'BIXOLON_SDK_40x30','showPrinters':false},

      ],
      selected_label  : 0,
      selected_printer: '',
      labelCount      : 0,
        msg           : {
        title : '',
        body  : '',
        type  : 0      
      },
      

      spinner         : true
    }
  },
  computed :{ 
    ...mapGetters(['company'])
  },
  methods: {

   _setLabelId(Id) 
   {
    

    console.log('PrinterId',Id)
    this.showPrinters =  this.label_list[Id].showPrinters
    

    
   },
   setDefault()
   {
     
     console.log(this.selected_label)
     localStorage.setItem("labelId", this.selected_label)
     localStorage.setItem("printerId", this.selected_printer)
     
     

   }, 
  zeroPad(input, length) {
        return (Array(length + 1).join('0') + input).slice(-length);
      },

  viewResult(result) {
	    	console.log(result)
	    },
  doPrintLabels()
     {
      
      
       if(this.label_list[this.selected_label].code == 'BIXOLON_SDK_40x30')   
      {
        		
        		let barCodeSymbol = 7
		        let barCodeHeight = 40
		        let barWidth      = 4
		        let nBarWidth     = 2
		        let barCodeHri    = 1
            this.clearBuffer()
            this.setLabelId(this.issueID)
            this.setWidth(320)
            const items = this.data

		for (let i = 0; i < items.length; i++) 
		{
        for (let j = 0; j < items[i].qty; j++) 
        {
		   
        const ean13    = items[i].barcode        
        const brand    = items[i].brand.substring(0,25)
        const sku      = items[i].sku.substring(0,30)
        const category = items[i].category_it.substring(0,30)
        let color      = items[i].color + ' ' + items[i].supplierColor
        color          = color.substring(0,40)
        const size     = items[i].size
        const price    = this.fmt1(items[i].retailPrice)
        const img_code = items[i].img        
        const description = items[i].description
        
		
  
		this.drawDeviceFont(brand,10,65,"0",1,2,0,0,0,0)
		this.drawDeviceFont(sku.substring(0,25),10,95,"0",1,2,0,0,0,0)
		this.drawDeviceFont(category,10,122,"0",1,2,0,0,0,0)
    //this.drawDeviceFont(description,10,170,"0",1,1,0,0,0,0)
		
    this.drawDeviceFont(color.substring(0,24),10,150,"0",1,2,0,0,0,0)

		//this.drawDeviceFont(color,15,156,"0",1,2,0,0,0,0)
    
    /*const x = 250
    const y = 200
    */

    const x = 10
    const y = 190

    this.drawDeviceFont("MIS.",x,y,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,x + 60,y-10,"0",2,2,0,0,0,0)			



    /*this.drawDeviceFont("MIS.",15,210,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,60,185,"0",3,3,0,0,0,0)			
    */
    
    this.drawDeviceFont("€",185,175,"0",2,2,0,0,0,1)      
		this.drawDeviceFont(price,295,158,"0",2,4,0,0,0,1)
    //this.drawDeviceFont(img_code,15,270,"0",1,2,0,0,0,0)
    

    this.draw1DBarcode(ean13,50 , 1, barCodeSymbol, nBarWidth, barWidth, barCodeHeight, 0, barCodeHri)

		this.printBuffer();
		
	

    }
		}
    
      const strSubmit = this.getLabelData();
      requestPrint('Printer1', strSubmit, this.viewResult);
      return
    }

      
      if(this.label_list[this.selected_label].code == 'BIXOLON_SDK_50x40')   
      {
        		
          

        		let barCodeSymbol = 7
		        let barCodeHeight = 40
		        let barWidth      = 4
		        let nBarWidth     = 2
		        let barCodeHri    = 1
            this.clearBuffer()
            this.setLabelId(this.issueID)
            this.setWidth(400)
            const items = this.data

		for (let i = 0; i < items.length; i++) 
		{
        for (let j = 0; j < items[i].qty; j++) 
        {
		   
        const ean13    = items[i].barcode        
        const brand    = items[i].brand.substring(0,25)
        const sku      = items[i].sku.substring(0,30)
        const category = items[i].category_it.substring(0,30)
        let color      = items[i].color + ' ' + items[i].supplierColor
        color          = color.substring(0,40)
        const size     = items[i].size
        const price    = this.fmt1(items[i].retailPrice)
        const img_code = items[i].img        
        const description = items[i].description
        
		
  
		this.drawDeviceFont(brand,10,70,"0",2,2,0,0,0,0)
		this.drawDeviceFont(sku.substring(0,25),10,100,"1",1,2,0,0,0,0)
		this.drawDeviceFont(category,10,140,"0",1,2,0,0,0,0)
    this.drawDeviceFont(description,10,170,"0",1,1,0,0,0,0)
		
    this.drawDeviceFont(color.substring(0,24),10,185,"0",1,2,0,0,0,0)

		//this.drawDeviceFont(color,15,156,"0",1,2,0,0,0,0)
    
    /*const x = 250
    const y = 200
    */

    const x = 15
    const y = 245

    this.drawDeviceFont("MIS.",x,y,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,x+45,y-25,"0",2,3,0,0,0,0)			



    /*this.drawDeviceFont("MIS.",15,210,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,60,185,"0",3,3,0,0,0,0)			
    */
    

		this.drawDeviceFont("€ " + price,360,235,"0",2,4,0,0,0,1)
    this.drawDeviceFont(img_code,15,270,"0",1,2,0,0,0,0)
    

    this.draw1DBarcode(ean13,50 , 5, barCodeSymbol, nBarWidth, barWidth, barCodeHeight, 0, barCodeHri)

		this.printBuffer();
		
	

    }
		}
    
      const strSubmit = this.getLabelData();
      requestPrint('Printer1', strSubmit, this.viewResult);
      return
    }



  if(this.label_list[this.selected_label].code == 'BIXOLON_SDK_CLUB')   
      {
        		
            if(this.company.Id != 1)
            {return}

        		let barCodeSymbol = 7
		        let barCodeHeight = 40
		        let barWidth      = 4
		        let nBarWidth     = 2
		        let barCodeHri    = 1
            this.clearBuffer()
            this.setLabelId(this.issueID)
            this.setWidth(560)
            const items = this.data

		for (let i = 0; i < items.length; i++) 
		{
        for (let j = 0; j < items[i].qty; j++) 
        {
		   
        const ean13    = items[i].barcode        
        const brand    = items[i].brand.substring(0,19)
        const sku      = items[i].sku.substring(0,30)
        const category = items[i].category.substring(0,30)
        let color      = items[i].color + ' ' + items[i].supplierColor
        color          = color.substring(0,40)
        const size     = items[i].size
        const price    = this.fmt1(items[i].retailPrice)
        let clubPrice   = this.compareAtPrice(items[i].retailPrice)

        if(clubPrice && this.label_list[this.selected_label].Id == 13)
        {          
          clubPrice = this.fmt1(clubPrice)
          this.drawBlock(380,10,545,145,'B',5);	
      	  this.drawDeviceFont("  SAPIA  ",380,15,"0",2,2,0,1,0,0)
		      this.drawDeviceFont("   CLUB   ",380,40,"0",2,2,0,1,0,0)
          this.drawDeviceFont("€ " + clubPrice,420,65,"1",1,4,0,0,0,0)
        }
        

		
  
		this.drawDeviceFont(brand,15,80,"0",2,2,0,0,0,0)
		this.drawDeviceFont(sku.substring(0,25),15,110,"1",1,2,0,0,0,0)
		this.drawDeviceFont(category,15,160,"0",1,2,0,0,0,0)
		
    this.drawDeviceFont(color.substring(0,24),15,195,"0",1,2,0,0,0,0)
		//this.drawDeviceFont(color,15,156,"0",1,2,0,0,0,0)
    const x = 250
    
    this.drawDeviceFont("MIS.",x,210,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,x+45,185,"0",3,3,0,0,0,0)			

    /*this.drawDeviceFont("MIS.",15,210,"0",1,1,0,0,0,0)
		this.drawDeviceFont(size,60,185,"0",3,3,0,0,0,0)			
    */
    

		this.drawDeviceFont("€ " + price,540,155,"0",2,4,0,0,0,1)

    

    this.draw1DBarcode(ean13,80 , 5, barCodeSymbol, nBarWidth, barWidth, barCodeHeight, 0, barCodeHri)

		this.printBuffer();
		
	

    }
		}
    
      const strSubmit = this.getLabelData();
      requestPrint('Printer1', strSubmit, this.viewResult);
      return
        
    }


     





    
      if(this.selected_printer === '' && !this.print2default) 
      {
        
        this.msg.title = 'ATTENZIONE '
        this.msg.type = 1
        this.msg.body = 'Seleziona una stampante'
        return;
      }


      let cpj = new JSPM.ClientPrintJob();
      
      if ( this.print2default ) 
      {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selected_printer);
      }


      let temp_code =  [{
                        "cmds"          : ["q240"],
                    
                        "barcode"       : 'B240,40,1,E30,2,6,45,B,',
                        "brand"         : 'A175,10,1,4,1,1,N,',
                        "category"      : 'A150,10,1,3,1,1,N,',
                        "sku"           : 'A125,10,1,4,1,1,N,',
                        "color"         : 'A90,10,1,3,1,1,N,',
                        "size"          : 'A60,10,1,4,2,1,N,',
                        "price"         : 'A60,140,1,4,2,1,N,',
                        "img"           : '',

                        "euro"          : 'E. '

                  }]

      let cmds     = ''



      let epl_code = [
                  
                  {
                  
                  "cmds"          : ["ZB","R0,280"],
      
                  "barcode"       : "B5,150,0,E30,2,6,60,B,",
                  "brand"         : "A0,5,0,1,1,2,N,",
                  "sku"           : "A0,30,0,3,1,2,N,",
                  "color"         : "A0,70,0,1,1,2,N,",
                  "category"      : "A0,100,0,1,1,2,N,",
                  "supplierColor" : "A330,30,0,2,1,2,N,",
                  "size"          : "A340,115,0,3,3,2,N,",
                  "material"      : "A0,140,0,1,1,1,N,",
                  "price"         : "A350,180,0,4,1,2,N,",
                  "img"           : "A330,65,0,2,1,2,N,"
                  },

                  {
                        "cmds"          : ["R0,0","oRE,128"],
                        "barcode"       : 'B280,10,0,E30,2,6,50,B,',
                        "sku"           : 'A260,65,0,4,1,1,N,',
                        "brand"         : 'A260,90,0,4,1,1,N,',
                        "category"      : 'A260,120,0,4,1,1,N,',
                        "color"         : 'A260,150,0,3,1,1,N,',
                        "supplierColor" : 'A260,180,0,1,1,1,N,',
                        "size"          : 'A260,210,0,4,1,2,N,',
                        "price"         : 'A410,230,0,4,1,2,N,',
                        "img"           : ""

                  }
                  ,{
                        "cmds"          : ["R0,0","oRE,128"],
                        "barcode"       : 'B280,5,0,E30,2,6,50,B,',
                        "sku"           : 'A260,65,0,4,1,1,N,',
                        "brand"         : 'A260,90,0,4,1,1,N,',
                        "category"      : 'A260,120,0,4,1,1,N,',
                        "color"         : 'A260,150,0,3,1,1,N,',
                        "size"          : 'A260,180,0,4,1,2,N,',
                        "price"         : 'A410,180,0,4,1,2,N,',
                        "img"           : ""

                  },
                  {
                        "cmds"          : ["e","O0220","f220","M1200","L"],

                        "barcode"       : '1F6202500290010',
                        "sku"           : '121100300780010',
                        "brand"         : '131100300900010',
                        "category"      : '121100200670010',
                        "color"         : '121100200170010',
                        "size"          : '131100200400117',
                        
                        "price"         : '141100200000065'



                  }
                  ,{

                        "cmds"          : ["R280,0","oRE,128"],
                        "barcode"       : 'B5,5,0,E30,2,6,45,B,',
                        "sku"           : 'A0,70,0,4,1,1,N,',
                        "brand"         : 'A0,95,0,4,1,1,N,',
                        "category"      : 'A0,120,0,4,1,1,N,',
                        "color"         : 'A0,160,0,3,1,1,N,',
                        "size"          : 'A0,180,0,4,1,2,N,',
                        "price"         : 'A150,180,0,4,1,2,N,',
                        //"img"           : "A150,160,0,1,1,1,N,",
                        "img"           : "",
                        "description"   : "A0,145,0,1,1,1,N,"

                  },
                    {
                        "cmds"          : ["R0,0","oRE,128"],
                        "barcode"       : 'B280,5,0,E30,2,6,45,B,',
                        "brand"         : 'A265,70,0,4,1,1,N,',
                        "category"      : 'A265,95,0,3,1,1,N,',
                        "sku"           : 'A265,120,0,4,1,1,N,',
                        "color"         : 'A265,150,0,2,1,1,N,',
                        "size"          : 'A265,180,0,4,1,2,N,',
                        "price"         : 'A410,180,0,4,1,2,N,',
                        "img"           : 'A560,10,1,2,1,1,N,'

                  },

                  {
                        "cmds"          : ["R0,0"],
                        "barcode"       : 'B280,5,0,E30,2,6,45,B,',
                        "brand"         : 'A265,70,0,4,1,1,N,',
                        "category"      : 'A265,95,0,3,1,1,N,',
                        "sku"           : 'A265,118,0,4,1,1,N,',
                        "color"         : 'A265,143,0,2,1,1,N,',
                        "size"          : 'A265,185,0,4,1,2,N,',
                        "price"         : 'A410,180,0,4,1,2,N,',
                        /*"img"           : 'A560,10,1,2,1,1,N,',*/
                        "img"           : 'A265,162,0,2,1,1,N,',

                        "euro"          : 'E. '

                  }, {
                        "cmds"          : ["R0,0","oRE,128"],
                        "barcode"       : 'B300,0,0,E30,2,6,50,B,',
                        "brand"         : 'A260,75,0,4,1,2,N,',
                        "sku"           : 'A260,125,0,4,1,1,N,',
                        
                        "category"      : 'A260,155,0,4,1,1,N,',
                        "color"         : 'A260,195,0,3,1,1,N,',
                        
                        "size"          : 'A260,215,0,3,1,2,N,',
                        "price"         : 'A450,215,0,4,1,2,N,',
                        "description"   : "A260,178,0,1,1,1,N,"
                       
                        

                  },
                  {
                        "cmds"          : ['^L'],
                        "barcode"       : 'BE,160,10,2,5,80,0,1,',
                        "brand"         : 'AT,10,100,40,40,0,0,0,0,',
                        "sku"           : 'AT,10,140,30,30,0,0,0,0,',
                        
                        "category"      : 'AT,10,170,30,30,0,0,0,0,',
                        "color"         : 'AT,10,230,30,30,0,0,0,0,',
                        
                        "size"          : 'AT,10,260,30,30,0,0,0,0,MIS. ',
                        "price"         : 'AT,210,235,50,50,0,0,0,0,',
                        "description"   : "AT,10,205,20,20,0,0,0,0,"
                       
                        

                  },
                  {
                        "cmds"          : [],
                        "barcode"       : '^FO195,10^BY2^BEN,40,Y,N^FD',
                        "brand"         : '^FO15,10^AQN,56,24^FD',
                        "sku"           : '^FO20,120^A0N30,30^FD',
                        
                        "category"      : '^FO20,85^A0N25,25^FD',
                        "color"         : '^FO20,160^A0N25,25^FD',
                        
                        "size"          : '^FO285,160^A0N,56,30^FD',
                        "price"         : '^FO240,230^APN,80,36^FD$',
                        "description"   : "^FO20,108^A0N10,10^FD"
                       
                        

                  },
                  {
                        "cmds"          : [],
                        "barcode"       : '^FO60,5^BY2^BEN,40,Y,N^FD',
                        "brand"         : '^FO10,107^A0N25,25^FD',
                        "sku"           : '^FO10,080^A0N30,30^FD',
                        
                        "category"      : '^FO10,134^A0N25,25^FD',
                        "color"         : '^FO10,185^A0N25,25^FD',
                        
                        "size"          : '^FO10,225^A0N25,35^FD',
                        "price"         : '^FWB^FO350,110^A0D,40,40^FR^FD$',
                        "labelPrice"    : "^FO150,260^A0N40,40^FD",
                        "promo"         : '^FWB^FO300,90^AD,35,15^FR^FD' ,
                        "euro"          : '^FO130,255^A0N30,30^FD$',
                        "description"   : "^FO10,158^A0N10,10^FD"
                        
                        
                  },
                  {
                        "cmds"          : [],
                        "barcode"       : '^FO470,10^BY2^BEN,40,Y,N^FD',
                        "brand"         : '^FO160,10^AQN,56,24^FD',
                        "sku"           : '^FO160,180^A0N25,25^FD',
                        
                        "category"      : '^FO160,85^A0N25,25^FD',
                        "color"         : '^FO160,265^A0N30,30^FD',
                        
                        "size"          : '^FO450,245^A0N,56,56^FD',
                        "price"         : '^FO550,280^APN,80,36^FD$',
                        "description"   : "^FO160,120^A0N30,30^FD",
                        "labelSeason"   : '^FO160,318^A0N,25,25^FD'
                       
                        

                  },
                  {
                        "cmds"          : ["ZB","R0,0","oRE,128"],
                        "barcode"       : 'B170,60,0,E30,2,6,70,B,',
                        "brand"         : 'A170,160,0,2,1,2,N,',
                        "sku"           : 'A220,210,0,2,1,2,N,',
                        
                        "category"      : 'A450,160,0,2,1,2,N,',
                        "color"         : 'A220,250,0,2,1,2,N,',
                        
                        "size"          : 'A450,80,0,2,2,3,N,',
                        "price"         : 'A550,240,0,2,1,4,N,',
                        "description"   : ""
                       
                        

                  },
         

        ]

     

      var items    = this.data;  
      
      var quote    = '"'
      var newLine  = "\x0A"
      var Euro     = '\x80 '
      var stx      = '\x02'
      
      var cr       = '\x0d'
      
     

      let epl = epl_code[this.selected_label]
     
      if(this.selected_label==16)
      {
        /* MIRO */
        epl = temp_code[0]
      }

      if(this.label_list[this.selected_label].code == 'EPL' || this.label_list[this.selected_label].code == 'GODEX_EPL' )
      {
        

        items.forEach(item => {
                                  
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 

            cmds += "N" + newLine
            
            epl.cmds.forEach(cmd=>{
              cmds += cmd + newLine
            })

            let img = item.img

            cmds += epl.barcode + quote + item.barcode + quote + newLine
            cmds += epl.sku + quote +  item.sku.toUpperCase() + quote + newLine
            cmds += epl.brand + quote +  item.brand + quote + newLine
            cmds += epl.category + quote +  item.category + quote + newLine
            cmds += epl.color + quote +  item.color + quote + newLine
            if(epl.supplierColor)
            {
              cmds += epl.supplierColor + quote +  item.supplierColor + quote + newLine
            }

            if(epl.material)
            {
              cmds += epl.material + quote +  item.material + quote + newLine  
            }

            

            if(item.size == 'OS')
            {
              item.size = 'UNI'
            }
           

            if(this.label_list[this.selected_label].code == 'GODEX_EPL')
            {
            
              cmds += epl.size + quote + 'mis. '  + item.size + quote + newLine
            }
            else
            {
              cmds += epl.size + quote + item.size + quote + newLine
            }
            if(epl.description)
            {
              cmds += epl.description + quote + item.description + quote + newLine
              
            }

            if(epl.img)
            {
              cmds += epl.img + quote + img + quote + newLine
              
            }
            if(epl.euro)
            {
              
              cmds += epl.price + quote + epl.euro + price + quote + newLine
            }
            else
            {
              cmds += epl.price + quote + Euro + price + quote + newLine  
            }
            
            cmds += 'P' + item.qty + newLine


            //console.log('EPL',cmds)
       
        });
        
        }
        else if (this.label_list[this.selected_label].code == 'DATAMAX')
        {

          // DATAMAX
          items.forEach(item => {
                                  
            
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
            epl.cmds.forEach(cmd=>{
              cmds += stx + cmd + cr
            })
            cmds += 'D11' +  cr 
            cmds += 'SC' +  cr
            cmds += 'H20' +  cr

            cmds += epl.barcode +  item.barcode + cr
            cmds += epl.sku +   item.sku.toUpperCase() + cr
            cmds += epl.brand +   item.brand + cr
            cmds += epl.category +    item.category + cr
            cmds += epl.color +   item.color + cr
            
            
            cmds +=  '121100300600117Mis.' + cr
            cmds +=  epl.size  + item.size + cr
            
           

            cmds += epl.price + 'E.' +  price + cr
            
            cmds += 'Q'  + this.zeroPad(item.qty,4) + cr
            cmds += 'E' + cr

       
        });
        
        }
        else if (this.label_list[this.selected_label].code == 'EZPL')
        {

        
          items.forEach(item => {
                                  
            
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
            
          
 
            
            epl.cmds.forEach(cmd=>{
              cmds +=  cmd + cr
            })

            
            cmds += epl.barcode +  item.barcode + cr
            cmds += epl.brand +   item.brand + cr
            cmds += epl.sku +   item.sku.toUpperCase() + cr
            cmds += epl.category +  item.category + cr
            if(epl.description)
            {
              cmds += epl.description +  item.description + cr
              
            }
            cmds += epl.color +   item.color + cr
            cmds +=  epl.size  + item.size + cr
            cmds += epl.price + 'E. ' +  price + cr

            
            
            cmds += '^P' + item.qty  + cr
            cmds += 'E' + cr    
            
          
          
         
       
        });

        
        
      }
      else if(this.label_list[this.selected_label].code == 'ZPL_STANDARD')  
      {

        const FS = '^FS'
        items.forEach(item => {
                                  
            
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
                                  
                                
                       
                                  
                                  epl.cmds.forEach(cmd=>{
                                    cmds +=  cmd + FS
                                  })
                                  cmds += '^XA^CI0,21,36'
                                  cmds += '^FO230,150  ^GB160,75,2^FS'
                                  cmds += '^FO10,150  ^GB210,75,2^FS'
                                  cmds += '^FO10,80  ^GB380,75,2^FS'
                                  cmds += '^LH0,0^FO245,155^APN,40,18^FDMis.' + FS
                                  
                                  cmds += epl.barcode +  item.barcode + FS
                                  cmds += epl.brand +   item.brand.substr(0,13) + FS
                                  cmds += epl.sku +   item.sku.toUpperCase() + FS
                                  cmds += epl.category +  item.category + FS
                                  if(item.description)
                                  {
                                    cmds += epl.description +  item.description + FS
                                    
                                  }
                                  cmds += epl.color +   item.color + FS
                                  if(item.size == 'OS')
                                  {                                    
                                    item.size = 'UNICA'
                                  }
                                  cmds +=  epl.size  + item.size + FS
                                  cmds += epl.price + ' ' +  price + FS
                      
                                  
                                  
                                  cmds += '^PQ' + item.qty 
                                  cmds += '^XZ'  
                                  
                                
                                
                               
                             
                              });
                      
                              
      }
     
     
      else if(this.label_list[this.selected_label].code == 'ZPL_DP')  
      {

        const FS = '^FS'
        items.forEach(item => {
                                  
            
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
                                  
                                
                       
                                  
                                  epl.cmds.forEach(cmd=>{
                                    cmds +=  cmd + FS
                                  })
                                  cmds += '^XA^CI0,21,36'
                                  
                                  cmds += '^FO340,5^GB220,290,100' + FS
                            
                                  cmds += '^FO10,210^A0N25,15^FDMis.' + FS
                                  
                                  cmds += epl.barcode +  item.barcode + FS
                                  cmds += epl.brand +   item.brand.substr(0,30) + FS
                                  cmds += epl.sku +   item.sku.toUpperCase().substr(0,30) + FS
                                  cmds += epl.category +  item.category + FS

                                  if(item.labelPrice)
                                  {
                                    /* DIAGONAL BAR */
                                    cmds += '^FO150,255^GD110,30,30,,R' + FS
                                    cmds += epl.labelPrice +  item.labelPrice + FS
                                    cmds += epl.euro + FS
                                  }

                                  if(item.description)
                                  {
                                    cmds += epl.description +  item.description + FS
                                    
                                  }
                                  cmds += epl.color +   item.color + FS
                                  if(item.size == 'OS')
                                  {
                                    
                                    item.size = 'UNICA'
                                  }
                                  cmds +=  epl.size  + item.size + FS
                                  cmds += epl.price + ' ' +  price + FS
                      
                                  
                                  
                                  cmds += '^PQ' + item.qty 
                                  cmds += '^XZ'  
                                  
                                
                                
                               
                             
                              });
                      
                              
      }
      else if(this.label_list[this.selected_label].code == 'BIXOLON_68_45')  
      {

        const FS = '^FS'
        items.forEach(item => {
                                  
            
            var price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
                                  
                                
                       
                                  
                                  epl.cmds.forEach(cmd=>{
                                    cmds +=  cmd + FS
                                  })
                                  cmds += '^XA^CI0,21,36'
                                  cmds += '^FO150,240^GB230,75,2^FS'
                                  
                                  cmds += '^FO420,235^APN,40,18^FDMis.' + FS
                                  
                                  cmds += epl.barcode +  item.barcode + FS
                                  cmds += epl.brand +   item.brand.substr(0,13) + FS
                                  cmds += epl.sku +   item.sku.toUpperCase() + FS
                                  cmds += epl.category +  item.category + FS
                                  if(item.description)
                                  {
                                    cmds += epl.description +  item.description + FS
                                    
                                  }
                                  cmds += epl.color +   item.color + FS
                                  if(item.size == 'OS')
                                  {                                    
                                    item.size = 'UNICA'
                                  }
                                  cmds +=  epl.size  + item.size + FS
                                  cmds += epl.price + ' ' +  price + FS
                                  cmds += epl.labelSeason + item.labelSeason + FS
                      
                                  
                                  
                                  cmds += '^PQ' + item.qty 
                                  cmds += '^XZ'  
                                  
                                
                                
                               
                             
                              });
                              
                      
                              
      } 

     

     



      else if(this.label_list[this.selected_label].code == 'HOLAMOSA')  
      {

       // cmds += 'A165,5,0,2,2,2,N,"       HOLA MOSA"' + newLine
        items.forEach(item => {
                                  
                                  let price = item.retailPrice.toLocaleString('de-DE',{minimumFractionDigits: 2, maximumFractionDigits: 2}).replace(',','_').replace('.',',').replace('_','.') 
                      
                                  cmds += "N" + newLine
                                  
                                  epl.cmds.forEach(cmd=>{
                                    cmds += cmd + newLine
                                  })
                      
                                  let img = item.img
                      
                                  
                                  cmds += 'A165,15,0,2,2,2,N,"       HOLA MOSA"' + newLine
                                  cmds += 'A450,60,0,1,1,1,N,"Mis."' + newLine
                                  cmds += 'A170,210,0,2,1,2,N,"ART."' + newLine
                                  cmds += 'A170,250,0,1,1,1,N,"Col."' + newLine
                                  
                                  
                                  cmds += epl.barcode + quote + item.barcode + quote + newLine
                                  cmds += epl.sku + quote +  item.sku.toUpperCase() + quote + newLine
                                  cmds += epl.brand + quote +  item.brand + quote + newLine
                                  cmds += epl.category + quote +  item.category + quote + newLine
                                  cmds += epl.color + quote +  item.color + quote + newLine
                                  cmds += epl.supplierColor + quote +  item.supplierColor + quote + newLine
                                  cmds += epl.material + quote +  item.material + quote + newLine
                                  cmds += epl.size + quote + item.size + quote + newLine

                                  if(item.size == 'OS')
                                  {
                                    item.size = 'UNI'
                                  }
                                 
                                  
                                  if(epl.description)
                                  {
                                    cmds += epl.description + quote + item.description + quote + newLine
                                    
                                  }
                      
                                  
                                  if(epl.euro)
                                  {
                                    
                                    cmds += epl.price + quote + epl.euro + price + quote + newLine
                                  }
                                  else
                                  {
                                    cmds += epl.price + quote + Euro + price + quote + newLine  
                                  }
                                  
                                  cmds += 'P' + item.qty + newLine
                      
                      
                             
                              });
                              



                              
      }  
          
        
        
        
        cpj.printerCommands = cmds;
        cpj.sendToClient();


    },

    
    
    onPrinterChange: function(value) 
    {
      this.selected_printer = value;
      
      
    
      
    },
    onInit: function() {
      
      

      JSPM.JSPrintManager.auto_reconnect = true;
      JSPM.JSPrintManager.start();
      JSPM.JSPrintManager.WS.onStatusChanged = () => {
        this.getPrinters().then((p)=>{
          this.printers = p.sort();
          this.spinner = false
          //this.selected_printer = localStorage.getItem("printerId");
          this.$nextTick();
        });
      };
    },

  
    getPrinters: function() {   
      return new Promise((ok, err) => {
        let printers = [];
        if(JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
          JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
            printers = myPrinters;
            //console.log(printers);
            ok(printers);
          }).catch((e)=>err(e));
        } else { console.warn("JSPM WS not open"); ok(printers); }
      });       
    }
  },
  mounted: function() {
    this.onInit();
  },
  created: function()
  {
    

    const labelId = localStorage.getItem("labelId")
    if(labelId)
    {
      this.selected_label   = localStorage.getItem("labelId");
      this.showPrinters     = this.label_list[this.selected_label].showPrinters
    }
    

    this.selected_printer = localStorage.getItem("printerId");
    
    
    
    

    this.data.forEach(item=>
    {
      this.labelCount += item.qty
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}

</style>
